<template>
  <component :id="id" :is="type" v-bind="props" v-on="events"></component>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String
    },
    type: {
      type: String,
      default: 'div',
    },
    props: {
      type: Object,
      default() {
        return {};
      }
    },
    events: {
      type: Object,
      default() {
        return {};
      }      
    }
  }
}
</script>